import Vue from 'vue';
import textfield from './textfield/textfield.vue';
import columns from './columns/columns.vue';
import select from './select/select.vue';
import file from './file/file.vue';
import button from './button/button.vue';
import datetime from './datetime/datetime.vue';
import textarea from './textarea/textarea.vue';
import number from './number/number.vue';
import checkbox from './checkbox/checkbox.vue';
import htmlelement from './htmlelement/htmlElement.vue';
import panel from './panel/panel.vue';
import fieldsets from './fieldset/fieldsets.vue';
import markentry from './markentry/markentry.vue';

const components = {
  'fw-textfield': textfield,
  'fw-columns': columns,
  'fw-select': select,
  'fw-file': file,
  'fw-button': button,
  'fw-datetime': datetime,
  'fw-textarea': textarea,
  'fw-number': number,
  'fw-checkbox': checkbox,
  'fw-htmlelement': htmlelement,
  'fw-panel':panel,
  'fw-fieldset':fieldsets,
  'fw-markentry':markentry
};

// Registering all components globally
Object.keys(components).forEach(name => {
  Vue.component(name, components[name]);
});
